import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const Header = () => (
  <header className="header-container container d-flex align-items-center justify-content-between p-3 flex-wrap">
    {/* For large screens */}
    <div className="d-none d-lg-flex w-100 justify-content-between align-items-center">
      {/* Logo */}
      <div className="header-img">
        <img
          src="https://dont-copy.netlify.app/assets/logo-S2lIhR8K.svg"
          width="162.57"
          height="24"
          alt="Logo"
        />
      </div>

      {/* Search Bar */}
      <form
        className="d-flex header-form"
        style={{
          width: "100%",
          maxWidth: "360px",
          borderRadius: "21px",
        }}
      >
        <button style={{border: "none", opacity: 0.5,}} className="custom-search" type="submit">
          <FontAwesomeIcon icon={faMagnifyingGlass} />
        </button>
        <input
          className="form-control custom-input-search"
          type="search"
          placeholder="Search for your favorite groups in ATG"
          aria-label="Search"
        />
      </form>

      {/* Create Account Button */}
      <div className="header-button">
        <button
          className="btn custom-btn-create"
          data-bs-toggle="modal"
          data-bs-target="#authModal"
        >
          Create Account. <span className="text-primary fw-bold">It's Free!</span>
        </button>
      </div>
    </div>

    {/* For small screens */}
    <div className="d-flex d-lg-none justify-content-between mt-3 w-100">
      <div className="d-flex align-items-center w-100 justify-content-between">
        <button className="btn">
          <img
            src="data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M16%207H3.83L9.42%201.41L8%200L0%208L8%2016L9.41%2014.59L3.83%209H16V7Z'%20fill='white'/%3e%3c/svg%3e"
            alt="Back"
          />
        </button>
        <button className="btn join-group ms-3">Leave Group</button>
      </div>
    </div>

    {/* Floating Button for Small Screens */}
    <button
      className="floating-btn d-lg-none"
      data-bs-toggle="modal"
      data-bs-target="#authModal"
    >
      <img
        src="data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='icon/image/edit_24px'%3e%3cpath%20id='icon/image/edit_24px_2'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M17.6588%203C17.4088%203%2017.1488%203.1%2016.9588%203.29L15.1288%205.12L18.8788%208.87L20.7088%207.04C21.0988%206.65%2021.0988%206.02%2020.7088%205.63L18.3688%203.29C18.1688%203.09%2017.9188%203%2017.6588%203ZM14.0588%209.02L14.9788%209.94L5.91878%2019H4.99878V18.08L14.0588%209.02ZM2.99878%2017.25L14.0588%206.19L17.8088%209.94L6.74878%2021H2.99878V17.25Z'%20fill='white'/%3e%3c/g%3e%3c/svg%3e"
        alt="Open Auth Modal"
      />
    </button>
  </header>
);

export default Header;
